import Bacon from "Bacon";

Bacon.Observable.prototype.lazyAssign = function (func, arg, method) {
  var args = [].slice.call(arguments, 3);
  this.onValue(function () {
    var obj = func(arg);
    obj[method].apply(obj, args.concat([].slice.call(arguments, 0)));
  });
};

export default Bacon;


// WEBPACK FOOTER //
// ./web/js/lib/Bacon.plugins.js